import { getRequest, sendFormDataRequest, sendRequest } from './api';

/**
 * Получение списка Мои организации.
 * @param {string} user_id - Идентификатор пользователя.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchMyOrganisation(user_id) {
  return getRequest(`/organisation`, { user_id });
}

/**
 * Обновление полей организации.
 * @param {object} data - Данные организации id обязательный!!!.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function saveOrganisationChanges(data) {
  return sendRequest('/organisation', 'PUT', data);
}
/**
 * Удаление организации id обязательный.
 * @param {string} id - id организации обязательный.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function deleteOrganisation(id) {
  return sendRequest('/organisation', 'DELETE', { id });
}
/**
 * Обновление изображения в компании
 * @param {*} organizationId
 * @param {*} imageFile
 * @returns
 */
export const changeOrganizationImage = async (organizationId, imageFile) => {
  const url = '/organisation/image/change'; // Относительный URL

  // Создаем объект FormData
  const formData = new FormData();
  formData.append('id', organizationId); // Добавляем ID организации
  formData.append('image', imageFile); // Добавляем изображение

  try {
    // Отправляем POST-запрос с FormData
    const result = await sendFormDataRequest(url, 'POST', formData);
    console.log('Изображение успешно обновлено:', result);
    return result;
  } catch (error) {
    console.error('Ошибка при отправке изображения:', error);
    throw error;
  }
};
/**
 * Создания изображения в компании
 * @param {*} imageFile
 * @returns
 */
export const createOrganizationImage = async (imageFile) => {
  const url = '/organisation/image/create'; // Относительный URL

  // Создаем объект FormData
  const formData = new FormData();
  formData.append('image', imageFile); // Добавляем изображение

  try {
    // Отправляем POST-запрос с FormData
    const result = await sendFormDataRequest(url, 'POST', formData);
    console.log('Изображение успешно обновлено:', result);
    return result;
  } catch (error) {
    console.error('Ошибка при отправке изображения:', error);
    throw error;
  }
};
/**
 * Удаление Изображения image обязательный.
 * @param {string} image - ссылка на изображение.
 *  @param {string} organisation_id - если появиться функционал удаления прикрепленных изображений к организации.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function removeImage(image) {
  return sendRequest('/organisation/image/delete', 'POST', { image });
}
// Схема перехода в связанный аккаунт

// 1.  GET: /api/user/relate параметр organisation_id
// В ответ приходит список user_id( это кружочки после нажатия на организацию)
/**
 * Получение списка Мои организации.
 * @param {string} organisation_id - Идентификатор организации.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchMyOrganizationMyAccounts(organisation_id) {
  return getRequest(`/user/relate`, { organisation_id });
}

// 2. POST: /api/user/relate/token в теле запроса параметры organisation_id, user_id.
// В ответ придут новые токены. Параллельно они должны установиться в куки бекендом

export async function crateTokenAcc(organisation_id, user_id) {
  return sendRequest('/user/relate/token', 'POST', { organisation_id, user_id });
}
// Синхронизация организаций
/**
 * Получение организаций для синхронизации.
 * @param {string} name - название организации.
 * @param {string} organisation_id - id организации с которой синхронизируют.
 * 
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function getSyncOrganisation(data) {
  return getRequest(`/organisation/sync`, data);
}

/**
 * Выбор организации. Синхронизация.
 * @param {object} data - параметр в теле запроса uuid организации из запроса выше.
 * @returns {Promise<any>} - Ответ от сервера .
 */
export async function syncOrganisationById(data) {
  return sendRequest('/organisation/sync', 'POST', data);
}
